import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M11 4h2","key":"svg-1"}],["path",{"d":"M12 17v.01","key":"svg-2"}]]

const IconDeviceMobile = createReactComponent('outline', 'device-mobile', 'DeviceMobile', __iconNode);

export default IconDeviceMobile;